export default __webpack_public_path__ + "static/media/twoColumns.a8fc9924.svg";